import {
  UpdateFindingsRequest,
  UpdateFindingsResponse,
} from "@protos/issues/v1/issues";
import { DEPLOYMENT_URL } from "@shared/constants";

import { authPatch } from "../auth/auth";

export const updateDeploymentFindingsBulkV2 = (
  deploymentId: number,
  request: UpdateFindingsRequest
) => {
  return authPatch<UpdateFindingsRequest, UpdateFindingsResponse>(
    `${DEPLOYMENT_URL}/${deploymentId}/findings/v2`,
    request
  );
};
